import React , {useState , useEffect} from 'react'
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';



function Mensaje() {
    const[titulo,setTitulo] = useState('');
    const[mensaje,setMensaje] = useState('');
    const [archivo, setArchivo] = useState('');
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    const getBanner = () => {
      const baseURL = process.env.REACT_APP_SERVER_PATH+'mensaje';
      fetch(`${baseURL}`)
      .then(res => res.json())
      .then(
        (result) => { 
          setTitulo(result[0].titulo);
          setMensaje(result[0].cuerpo);
           
        },
        (error) => {
        }
      )
     }

     const handleSubmit = async (event) => {
      event.preventDefault();

      const formData = new FormData();
      formData.append('sampleFile', archivo);
      
          //
          try {
              const baseURL = process.env.REACT_APP_SERVER_PATH + 'upload';
              const res = await fetch(`${baseURL}`, {
                method: "POST",
                body: formData,
              });
    
              if (res.status === 200) {
                setTitulo('Información');
                setMensaje('Envio correcto')
                 setOpen(true);
                
              } else
              if (res.status === 500) 
               {
                setTitulo('Error');
                setMensaje('Error al enviar el archivo')
                 setOpen(true);
               }

                  } catch (err) {
                    setTitulo('Error');
                setMensaje('Error al enviar el archivo')
                 setOpen(true);
                  console.log(err.message)
            }
          //
    };


    const handleFileChange = (event) => {
        setArchivo(event.target.files[0]);
      };

      useEffect( () => {
    
      
       // eslint-disable-next-line react-hooks/exhaustive-deps         
  },[])

  return (
    
    <>

<Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {titulo}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {mensaje}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>

    <Container sx={{ mt: 10, mb: 1 }}>
   
    <Box component="form" onSubmit={handleSubmit} encType="multipart/form-data" sx={{ mt: 3 }}>
        <h1>Banner</h1>
         <input
        accept=".jpg,.png"
        style={{ display: 'none' }}
        id="file-input"
        type="file"
        name="sampleFile"
        onChange={handleFileChange}
      />
      <label htmlFor="file-input">
        <Button variant="contained" color="primary" component="span">
          Seleccionar archivo
        </Button>
      </label>
     {archivo && <p>Archivo seleccionado: {archivo.name}</p>}
      <br/>
      <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
          Guardar cambios
        </Button>
      </Box>
    </Container>
        
    </>
  )
}

export default Mensaje

/*


*/ 